"use client";

import { Core } from "@faire/design-tokens";
import { createSVGIconV2 } from "@faire/web/slate/icons/lib/createSVGIconV2";
import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

// Implemented using the icons from here: https://faire-wholesale.slack.com/archives/C08PZGMUC3Z/p1756238353493689?thread_ts=1756237700.863289&cid=C08PZGMUC3Z
export const Information = createSVGIconV2(
  <>
    <path
      d="M12 1.5C14.7848 1.5 17.4557 2.60606 19.4248 4.5752C21.3939 6.54433 22.5 9.21523 22.5 12C22.5 14.7848 21.3939 17.4557 19.4248 19.4248C17.4557 21.3939 14.7848 22.5 12 22.5C9.21523 22.5 6.54433 21.3939 4.5752 19.4248C2.60606 17.4557 1.5 14.7848 1.5 12C1.5 9.21523 2.60606 6.54433 4.5752 4.5752C6.54433 2.60606 9.21523 1.5 12 1.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 10.75V16.75"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 8C11 8.26522 11.1054 8.51957 11.2929 8.70711C11.4804 8.89464 11.7348 9 12 9C12.2652 9 12.5196 8.89464 12.7071 8.70711C12.8946 8.51957 13 8.26522 13 8C13 7.73478 12.8946 7.48043 12.7071 7.29289C12.5196 7.10536 12.2652 7 12 7C11.7348 7 11.4804 7.10536 11.2929 7.29289C11.1054 7.48043 11 7.73478 11 8Z"
      fill="currentColor"
    />
  </>,
  { displayName: "Information", scalingFactor: 139 / 133 },
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    color: Core.icon.default,
    titleAccess: strictLocalize({
      id: "DTzrKo",
      defaultMessage: "Information",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    className: legacyIconCls(),
  })
);
